import { Environment } from 'src/app/utils/interfaces/environment';

export const environment: Environment = {
  production: true,
  origin: 'https://gg66api.gg66game-ggwp.space/',
  image: 'https://gg66api.gg66game-ggwp.space/images/',
  name: 'production',
};
